module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (19).7d236549.jpg";